import { TextNode, Caption } from '../textNodes'

export default ({ fileInputRef, onChange }) => (
  <div className="burosferaVacancyForm-imageUploaderPlaceholder">
    <label htmlFor="burosferaVacancyForm-image">
      <TextNode>Перетащите иллюстрацию на страницу</TextNode>
      <Caption>Лучше всего — от 2000 пикселей в ширину и с пропорциями 16:9</Caption>
    </label>

    <input type="file"
      id="burosferaVacancyForm-image"
      accept="image/jpeg,image/png,image/gif"
      ref={ fileInputRef }
      onChange={ onChange } />
  </div>
)
